import React from "react";

export default function FullStackImg(props) {
  const theme = props.theme;
  return (
    <svg
      id="ade8c9af-7e2e-4eda-b5c8-b06129257226"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="1098.75"
      height="632.37039"
      viewBox="0 0 1098.75 632.37039"
    >
      <title>heatmap</title>
      <ellipse
        cx="549.375"
        cy="600.77366"
        rx="549.375"
        ry="31.59674"
        fill={theme.compImgHighlight}
      />
      <rect
        x="174.96748"
        width="825.31765"
        height="26.25696"
        fill={theme.compImgHighlight}
      />
      <circle
        cx="197.05271"
        cy="12.74148"
        r="6.79546"
        fill={theme.imageHighlight}
      />
      <circle
        cx="219.13794"
        cy="12.74148"
        r="6.79546"
        fill={theme.imageHighlight}
      />
      <circle
        cx="241.22317"
        cy="12.74148"
        r="6.79546"
        fill={theme.imageHighlight}
      />
      <polygon
        points="175.552 415.277 174.967 415.779 174.967 592.903 1000.285 592.903 1000.285 281.779 990.449 282.525 175.552 415.277"
        fill={theme.text}
      />
      <rect
        x="234.5289"
        y="175.64069"
        width="230.47032"
        height="9.29316"
        fill={theme.text}
      />
      <rect
        x="234.5289"
        y="196.08564"
        width="230.47032"
        height="9.29316"
        fill={theme.text}
      />
      <rect
        x="234.5289"
        y="216.53058"
        width="78.06253"
        height="9.29316"
        fill={theme.text}
      />
      <rect
        x="704.5289"
        y="433.64069"
        width="230.47032"
        height="9.29316"
        fill="#fff"
      />
      <rect
        x="704.5289"
        y="454.08564"
        width="230.47032"
        height="9.29316"
        fill="#fff"
      />
      <rect
        x="704.5289"
        y="474.53058"
        width="78.06253"
        height="9.29316"
        fill="#fff"
      />
      <circle
        cx="561.33549"
        cy="575.26922"
        r="9.0658"
        fill={theme.compImgHighlight}
      />
      <circle
        cx="587.6263"
        cy="576.1758"
        r="9.0658"
        fill={theme.compImgHighlight}
      />
      <circle
        cx="613.91711"
        cy="577.08238"
        r="9.0658"
        fill={theme.compImgHighlight}
      />
      <circle cx="587.70943" cy="576.1758" r="7.25264" fill={theme.text} />
      <rect
        x="310.5289"
        y="282.01368"
        width="78.06253"
        height="17.81006"
        fill={theme.text}
      />
      <rect
        x="774.5289"
        y="523.01368"
        width="78.06253"
        height="17.81006"
        fill="#fff"
      />
      <circle
        cx="350"
        cy="291.01368"
        r="54"
        fill={theme.imageHighlight}
        opacity="0.3"
      />
      <circle
        cx="350"
        cy="291.01368"
        r="36"
        fill={theme.imageHighlight}
        opacity="0.3"
      />
      <circle cx="350" cy="291.01368" r="25" fill={theme.imageHighlight} />
      <circle
        cx="804.375"
        cy="157.1852"
        r="54"
        fill={theme.imageHighlight}
        opacity="0.3"
      />
      <circle
        cx="804.375"
        cy="157.1852"
        r="36"
        fill={theme.imageHighlight}
        opacity="0.3"
      />
      <circle cx="804.375" cy="157.1852" r="25" fill={theme.imageHighlight} />
      <circle
        cx="814"
        cy="532.01368"
        r="54"
        fill={theme.imageHighlight}
        opacity="0.3"
      />
      <circle
        cx="814"
        cy="532.01368"
        r="36"
        fill={theme.imageHighlight}
        opacity="0.3"
      />
      <circle cx="814" cy="532.01368" r="25" fill={theme.imageHighlight} />
      <rect
        x="141.09287"
        y="215.02041"
        width="22.24232"
        height="28.59727"
        transform="translate(244.80285 330.54921) rotate(-177.77929)"
        fill={theme.imageHighlight}
      />
      <path
        d="M241.91491,314.67894s30.77895-14.70576,30.28646-2.00541-31.02521,21.05594-31.02521,21.05594Z"
        transform="translate(-50.625 -133.8148)"
        fill="#ffb9b9"
      />
      <path
        d="M225.02834,422.13944S239.54941,457.681,244.9146,483.328s13.53608,60.94229,3.02582,85.97362-40.39191,98.59934-40.69972,106.53706,2.55946,15.99857-3.79071,15.75232-40.90677-11.12588-42.30963-15.95007,11.79-17.032,11.79-17.032l32.57732-102.08224L171.5182,490.02139l-24.51648,99.215-4.80184,123.82843s-23.56691-7.2736-26.98824-1.04655c0,0-10.55875-14.71883-11.90005-21.13057s4.98653-128.59106,4.98653-128.59106-21.63236-139.16289-4.16937-138.4857S189.99232,382.62245,225.02834,422.13944Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.dark}
      />
      <path
        d="M203.69623,685.2408s16.10862,35.60315,17.63461,37.25226,12.02317,17.95548,4.08545,17.64767-26.68044-8.98428-40.47584-22.23869-31.98406-36.21877-30.33495-37.74475,12.9466-5.85768,12.9466-5.85768Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.dark}
      />
      <path
        d="M139.33261,705.00394s.97192,15.937,3.90076,22.4103,2.55947,15.99856-5.37825,15.69075-28.45267-4.2832-28.45267-4.2832-1.21817-9.58683.43093-11.11281,8.67647-18.74272,5.68607-23.62847S139.33261,705.00394,139.33261,705.00394Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.dark}
      />
      <path
        d="M127.58939,187.8209s-16.922,26.37263-23.51842,32.47656,11.9616,19.543,11.9616,19.543l33.2153,4.46789s-.41786-30.2249,1.29281-33.33842S127.58939,187.8209,127.58939,187.8209Z"
        transform="translate(-50.625 -133.8148)"
        fill="#ffb9b9"
      />
      <path
        d="M156.45992,222.329s-6.84267,12.45411-13.19285,12.20786-39.1961-14.2394-40.599-19.0636-10.87963,34.5566-10.87963,34.5566L172.16,391.47053l19.60459-13.54915-9.49913-83.04478-7.80153-44.8206Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.imageHighlight}
      />
      <path
        d="M99.70361,348.91253c3.206,6.70666,5.20835,13.70047,4.9307,20.86031-.01231.31753-.02462.635-.05282.95187-.76057,14.69329-6.17341,31.68645-8.11534,44.04442-1.40908,8.86485-1.00808,15.33552,4.1797,16.85636,12.57723,3.66759-1.83379,6.28862,46.826,22.48494s57.15159,2.21623,57.27471-.95886-6.89116-27.29606-5.24206-28.822,23.07442,19.974,29.54772,17.04512.73874-19.05053.73874-19.05053-14.58264-33.954-14.27483-41.89176-22.08942-45.37466-22.08942-45.37466L178.193,235.89122s-5.85768-12.9466-13.73384-14.84195-14.411,2.621-14.411,2.621L163.228,252.80015l13.90546,51.417-2.32629,18.989s-16.17018-34.0156-26.7905-47.14689-33.26379-44.21805-33.26379-44.21805-5.28646-17.83738-1.2957-23.16791c3.99136-5.34632-16.64671-6.14663-25.4463,15.77118-4.66382,11.61641-12.23581,28.93924-16.97922,45.068-4.22682,14.28852-6.22343,27.646-2.03588,35.28111C75.396,316.45748,91.4958,331.78866,99.70361,348.91253Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.jacketColor}
      />
      <path
        d="M68.99574,304.79359c6.40029,11.66389,22.50006,26.99507,30.70787,44.11894,2.14378-7.72349,4.75909-15.71476,4.75909-15.71476s10.03082-53.66869-19.64-67.53872a19.85762,19.85762,0,0,0-13.79106,3.85343C66.8048,283.801,64.80819,297.15851,68.99574,304.79359Z"
        transform="translate(-50.625 -133.8148)"
        opacity="0.1"
      />
      <path
        d="M186.7818,301.41146l25.15446,7.33517,34.926,1.35436,3.593,30.348L193.05735,344.583S178.721,304.27874,186.7818,301.41146Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.jacketColor}
      />
      <path
        d="M145.764,403.451s33.65163,5.58313,25.971,15.7098-37.49194-.51979-37.49194-.51979Z"
        transform="translate(-50.625 -133.8148)"
        fill="#ffb9b9"
      />
      <path
        d="M104.58149,370.72471c-.76057,14.69329-6.17341,31.68645-8.11534,44.04442,10.72016,10.14608,20.91438,19.09523,24.75621,19.24421,7.93772.30781,20.69963-.78723,25.4007.985s7.4583-28.32955,7.4583-28.32955-2.80572-9.64839-15.32139-14.90351C130.31217,388.21008,114.119,378.56726,104.58149,370.72471Z"
        transform="translate(-50.625 -133.8148)"
        opacity="0.1"
      />
      <path
        d="M85.19206,256.13379s-26.86513-4.22165-25.41378,40.35271-2.83185,73.027,7.97315,81.39568,45.90258,46.29809,53.8403,46.6059,20.69964-.78724,25.40071.985,7.45829-28.32954,7.45829-28.32954S151.645,387.49514,139.12935,382.24s-42.00182-23.88779-41.75558-30.238,7.4583-28.32955,7.4583-28.32955S114.8629,270.00382,85.19206,256.13379Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.jacketColor}
      />
      <circle cx="100.65442" cy="58.10462" r="34.95222" fill="#ffb9b9" />
      <path
        d="M174.81363,141.82272a6.74905,6.74905,0,0,0,2.93882,1.47478,2.09716,2.09716,0,0,0,2.43029-1.68345c.79968,1.65841,1.70192,3.42593,3.33461,4.27689s4.15732.13741,4.39266-1.68864a7.706,7.706,0,0,0,1.77364,3.74392c1.013.96584,2.85,1.20961,3.73439.12482-.715,3.90745-.27369,7.92586-.49823,11.89184s-1.2821,8.17049-4.27847,10.7784c-4.36987,3.80334-10.94108,2.86467-16.68929,2.1441a5.06575,5.06575,0,0,0-2.61539.14307c-2.15231.917-2.05467,3.9131-2.08369,6.25243a17.37275,17.37275,0,0,1-15.21221,16.49749,8.70861,8.70861,0,0,1-6.47244-1.57964c-1.63206-1.38336-2.46572-3.63806-4.33585-4.67724-3.04207-1.6904-6.73153.77486-8.95568,3.45158s-4.4162,5.96933-7.86172,6.45932c-4.55691.648-8.02766-3.996-9.73047-8.27217a48.223,48.223,0,0,1,.95837-37.46978C125.15791,132.94937,157.66118,129.66876,174.81363,141.82272Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.dark}
      />
      <path
        d="M1013.84731,697.58434c12.30975,20.99239,37.13647,29.30353,37.13647,29.30353s4.86866-25.72424-7.44108-46.71664-37.13647-29.30354-37.13647-29.30354S1001.53756,676.59194,1013.84731,697.58434Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.compImgHighlight}
      />
      <path
        d="M1021.52851,690.25752c21.28835,11.79052,30.20667,36.40565,30.20667,36.40565s-25.59693,5.49892-46.88529-6.2916-30.20667-36.40564-30.20667-36.40564S1000.24015,678.467,1021.52851,690.25752Z"
        transform="translate(-50.625 -133.8148)"
        fill={theme.imageHighlight}
      />

      {/* Mobile app device — Flutter / React Native */}
      <g transform="translate(920 210)">
        <rect
          x="0"
          y="0"
          width="110"
          height="220"
          rx="16"
          fill={theme.compImgHighlight}
        />
        <rect
          x="8"
          y="18"
          width="94"
          height="174"
          rx="4"
          fill={theme.imageHighlight}
        />
        <rect
          x="18"
          y="36"
          width="74"
          height="10"
          rx="2"
          fill="#fff"
          opacity="0.85"
        />
        <rect
          x="18"
          y="56"
          width="54"
          height="7"
          rx="2"
          fill="#fff"
          opacity="0.55"
        />
        <rect
          x="18"
          y="72"
          width="62"
          height="7"
          rx="2"
          fill="#fff"
          opacity="0.55"
        />
        <rect
          x="18"
          y="100"
          width="74"
          height="48"
          rx="6"
          fill="#fff"
          opacity="0.25"
        />
        <circle cx="55" cy="206" r="8" fill={theme.text} opacity="0.35" />
        <rect
          x="42"
          y="8"
          width="26"
          height="5"
          rx="2.5"
          fill={theme.text}
          opacity="0.4"
        />
      </g>
      {/* Sync arc: desktop ↔ mobile */}
      <path
        d="M820 200 Q890 160 940 230"
        fill="none"
        stroke={theme.accentColor}
        strokeWidth="3"
        strokeDasharray="6 6"
        opacity="0.7"
      />
      <circle cx="940" cy="230" r="6" fill={theme.accentColor} />
    </svg>

    // <svg
    //   id="ade8c9af-7e2e-4eda-b5c8-b06129257226"
    //   width="100%"
    //   height="100%"
    //   viewBox="0 0 1076.06371 755.2279"
    // >
    //   <path
    //     d="M926.11393,774.80937c-6.98452,26.59789-31.459,43.21966-31.459,43.21966s-13.15033-26.50193-6.16581-53.09982,31.459-43.21966,31.459-43.21966S933.09845,748.21148,926.11393,774.80937Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <path
    //     d="M915.52,769.18266c-19.56251,19.32716-21.75117,48.83128-21.75117,48.83128s29.52845-1.83141,49.091-21.15858,21.75116-48.83129,21.75116-48.83129S935.08248,749.85549,915.52,769.18266Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.accentColor}
    //   />
    //   <path
    //     d="M206.70221,674.19438h36.8414l90.78774-35.52564s64.47245-26.31528,59.20939,23.68376-14.47341,117.103-14.47341,117.103-28.94681-13.15764-44.736-9.21035-5.26306-80.26162-5.26306-80.26162-128.9449,61.84092-140.78678,53.94634-14.4734-63.15669-14.4734-63.15669Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.imageClothes}
    //   />
    //   <path
    //     d="M206.70221,674.19438h36.8414l90.78774-35.52564s64.47245-26.31528,59.20939,23.68376-14.47341,117.103-14.47341,117.103-28.94681-13.15764-44.736-9.21035-5.26306-80.26162-5.26306-80.26162-128.9449,61.84092-140.78678,53.94634-14.4734-63.15669-14.4734-63.15669Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     opacity="0.1"
    //   />
    //   <path
    //     d="M264.74607,558.82036l44.58576,64.05921L413.2772,709.72s96.0508,22.368,82.89315,38.15717S402.75109,732.088,402.75109,732.088s-119.73455-86.84044-123.68184-93.41927S231.70174,570.249,231.70174,570.249Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.skinColor2}
    //   />
    //   <path
    //     d="M264.74607,558.82036l44.58576,64.05921L413.2772,709.72s96.0508,22.368,82.89315,38.15717S402.75109,732.088,402.75109,732.088s-119.73455-86.84044-123.68184-93.41927S231.70174,570.249,231.70174,570.249Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     opacity="0.1"
    //   />
    //   <path
    //     d="M238.28056,507.09232l28.94681,56.57786s-6.57882,27.63105-17.10494,30.26258-55.26209-34.20987-55.26209-34.20987Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.accentColor}
    //   />
    //   <path
    //     d="M238.28056,507.09232l28.94681,56.57786s-6.57882,27.63105-17.10494,30.26258-55.26209-34.20987-55.26209-34.20987Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     opacity="0.1"
    //   />
    //   <path
    //     d="M591.4193,644.90044,599.97,680.172a2.20311,2.20311,0,0,1-.04279,1.19048L561.13956,802.57374a2.20306,2.20306,0,0,1-4.28722-.42269l-5.36581-47.21916a2.203,2.203,0,0,1,.09431-.93128L587.1836,644.737A2.20306,2.20306,0,0,1,591.4193,644.90044Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.imageClothes}
    //   />
    //   <polygon
    //     points="526.306 575.493 534.2 605.756 499.99 716.28 492.096 682.07 526.306 575.493"
    //     fill="#f2f2f2"
    //   />
    //   <path
    //     d="M415.90873,812.34963c1.31577,3.94729,136.83949-1.31577,138.15525-2.63153a28.56086,28.56086,0,0,0,2.89462-5.26306c1.2369-2.63153,2.36844-5.26306,2.36844-5.26306L554.064,756.58753l-134.208-4.76306s-3.35527,36.10458-4.03949,52.63057C415.64564,808.626,415.64564,811.56012,415.90873,812.34963Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.imageClothes}
    //   />
    //   <polygon
    //     points="474.991 689.965 477.622 726.806 418.413 726.806 418.413 689.965 474.991 689.965"
    //     opacity="0.1"
    //   />
    //   <polygon
    //     points="398.677 701.806 399.03 701.736 397.361 717.596 364.467 717.596 364.467 701.806 398.677 701.806"
    //     opacity="0.1"
    //   />
    //   <path
    //     d="M415.90873,812.34963c1.31577,3.94729,136.83949-1.31577,138.15525-2.63153a28.56086,28.56086,0,0,0,2.89462-5.26306H415.81654C415.64564,808.626,415.64564,811.56012,415.90873,812.34963Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     opacity="0.1"
    //   />
    //   <circle
    //     cx="196.04888"
    //     cy="357.07618"
    //     r="59.20939"
    //     fill={theme.skinColor}
    //   />
    //   <path
    //     d="M254.06973,482.0928s-19.73647,34.20987-23.68376,52.63057-59.20939-36.8414-59.20939-36.8414l-7.2367-19.07858s51.97268-24.34164,48.02539-44.07811S254.06973,482.0928,254.06973,482.0928Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.skinColor}
    //   />
    //   <path
    //     d="M264.59584,584.72241l53.94634,71.05127,128.9449,96.05079s93.41926,19.73647,72.367,34.20987-81.57738-13.15764-81.57738-13.15764S308.01606,703.14119,280.385,674.19438s-78.94585-77.63009-78.94585-77.63009Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.skinColor}
    //   />
    //   <path
    //     d="M192.22881,695.24661,208.018,720.24613l94.2313-29.64581c20.67581-6.50474,43.34783-4.11124,61.68676,7.44229,16.44706,10.36164,26.97317,26.80869,3.28941,51.15033-47.36751,48.68328-78.94585,22.368-78.94585,22.368S129.07212,846.5595,102.75684,809.7181s-27.631-55.2621-27.631-55.2621S176.43964,691.29931,192.22881,695.24661Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.imageClothes}
    //   />
    //   <path
    //     d="M389.59345,782.08705s42.10445,27.63105-7.89459,40.78869-86.84044-5.26306-86.84044-5.26306-43.42022,0-43.42022-22.368,14.47341-24.99952,14.47341-24.99952l44.736,6.57882S364.59393,762.35059,389.59345,782.08705Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.accentColor}
    //   />
    //   <path
    //     d="M306.58925,414.56777c4.03,1.79653,8.02621,3.92291,12.40755,4.4444s9.37055-1.00819,11.44376-4.903c1.11982-2.10373,1.24778-4.57826,1.3-6.96089.15849-7.22517-.36406-15.03591-4.94264-20.6274-2.9139-3.55854-7.16747-5.80183-10.18374-9.274-2.161-2.48761-3.59924-5.50284-5.14786-8.41141-5.866-11.01725-14.55128-21.60559-26.62195-24.78175-5.04041-1.32629-10.328-1.26157-15.53945-1.188l-30.39725.42884c-4.91906.0694-9.914.15005-14.623,1.57383-9.784,2.95823-16.90779,11.18591-23.43216,19.05427-4.88119,5.88668-9.7753,11.83425-13.43862,18.54685a65.07888,65.07888,0,0,0-7.71423,31.88675,29.83261,29.83261,0,0,0,1.09276,8.43732,46.82177,46.82177,0,0,0,3.31627,7.28423c5.70049,11.19673,9.08523,25.18219,2.66543,35.98258,11.15187-4.55542,22.18591-10.52835,29.54232-20.0677,3.29093-4.26748,5.87181-9.26316,10.25758-12.39472s11.532-3.40321,14.34592,1.1928a12.85719,12.85719,0,0,1,1.4508,6.02242c.20551,3.44983.1999,7.03258,1.66258,10.16374s4.94686,5.65758,8.27337,4.72061c5.72869-1.61358,5.18009-10.406,9.59251-14.4,3.35094-3.03318,8.52074-2.45334,12.82574-3.83026,5.01582-1.60428,8.77937-5.94959,10.92379-10.75939,1.63-3.65594,1.60645-13.223,4.69084-15.20283C294.20755,409.02219,303.00386,412.96943,306.58925,414.56777Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.dark}
    //   />
    //   <path
    //     d="M159.2397,472.56207a15.61579,15.61579,0,0,1,8.128.02069c8.44618,2.26753,27.38021,8.27035,31.43989,17.40462,5.26306,11.84188,23.68376,30.26258,23.68376,30.26258s24.99952,24.99952,19.73646,42.10446-24.99952,36.8414-24.99952,36.8414,5.26306,81.57738-21.05223,102.62961-36.8414,6.57882-36.8414,26.31528S77.75732,809.7181,61.96814,771.56094c0,0,7.89459-71.05128,5.26306-96.0508C64.63762,650.87116,68.43448,497.14537,159.2397,472.56207Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.accentColor}
    //   />
    //   <path
    //     d="M201.43916,505.77655s80.26162,59.2094,65.78821,84.20892c0,0-48.68328,23.68375-59.20939,22.368s-51.31481-47.36751-61.84092-51.31481S130.38789,486.04009,201.43916,505.77655Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill={theme.accentColor}
    //   />
    //   <circle cx="498.06371" cy="237.45791" r="65" fill={theme.accentColor} />
    //   <path
    //     d="M1096.8978,225.42666H732.64912V149.20722H1096.8978ZM734.25374,223.822h361.03944v-73.0102H734.25374Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <rect
    //     x="645.80936"
    //     y="92.06506"
    //     width="362.64407"
    //     height="74.61482"
    //     fill={theme.accentColor}
    //   />
    //   <circle cx="416.56486" cy="15.24386" r="5.61624" fill="#e2405f" />
    //   <circle cx="435.8203" cy="15.24386" r="5.61624" fill="#e2405f" />
    //   <circle cx="455.07573" cy="15.24386" r="5.61624" fill="#e2405f" />
    //   <path
    //     d="M1138.03186,512.05187H462.48693V72.38605h675.54493Zm-673.94031-1.60462h672.33569V73.99067H464.09155Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <rect
    //     x="401.3211"
    //     y="24.33804"
    //     width="673.9403"
    //     height="1.60462"
    //     fill="#3f3d56"
    //   />
    //   <path
    //     d="M480.13775,91.64149a6.41848,6.41848,0,1,1,6.41848-6.41848A6.42592,6.42592,0,0,1,480.13775,91.64149Zm0-11.23234a4.81386,4.81386,0,1,0,4.81386,4.81386A4.81945,4.81945,0,0,0,480.13775,80.40915Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <path
    //     d="M499.39319,91.64149a6.41848,6.41848,0,1,1,6.41848-6.41848A6.42592,6.42592,0,0,1,499.39319,91.64149Zm0-11.23234a4.81386,4.81386,0,1,0,4.81386,4.81386A4.81945,4.81945,0,0,0,499.39319,80.40915Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <path
    //     d="M518.64863,91.64149A6.41848,6.41848,0,1,1,525.0671,85.223,6.42593,6.42593,0,0,1,518.64863,91.64149Zm0-11.23234a4.81386,4.81386,0,1,0,4.81385,4.81386A4.81946,4.81946,0,0,0,518.64863,80.40915Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <rect
    //     x="612.10922"
    //     y="25.14035"
    //     width="1.60462"
    //     height="414.34565"
    //     fill="#3f3d56"
    //   />
    //   <rect
    //     x="688.73293"
    //     y="228.85889"
    //     width="117.93955"
    //     height="16.0462"
    //     fill="#f2f2f2"
    //   />
    //   <rect
    //     x="874.06652"
    //     y="228.85889"
    //     width="117.93955"
    //     height="16.0462"
    //     fill="#f2f2f2"
    //   />
    //   <path
    //     d="M875.86143,310.07035H756.31726V292.41953H875.86143Zm-117.93955-1.60462H874.25681V294.02415H757.92188Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <rect
    //     x="688.73293"
    //     y="353.21693"
    //     width="117.93955"
    //     height="16.0462"
    //     fill="#f2f2f2"
    //   />
    //   <path
    //     d="M875.86143,434.42838H756.31726V416.77757H875.86143Zm-117.93955-1.60462H874.25681V418.38219H757.92188Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <rect
    //     x="689.13409"
    //     y="289.43329"
    //     width="303.27314"
    //     height="16.0462"
    //     fill="#f2f2f2"
    //   />
    //   <path
    //     d="M1061.59617,372.24937H756.71841V354.59855h304.87776ZM758.323,370.64475h301.66852V356.20317H758.323Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <path
    //     d="M1061.195,310.07035H941.65084V292.41953H1061.195Zm-117.93955-1.60462h116.33493V294.02415H943.25546Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <path
    //     d="M571.03186,357.844a66,66,0,1,1,66-66A66.07468,66.07468,0,0,1,571.03186,357.844Zm0-130a64,64,0,1,0,64,64A64.0727,64.0727,0,0,0,571.03186,227.844Z"
    //     transform="translate(-61.96814 -72.38605)"
    //     fill="#3f3d56"
    //   />
    //   <rect x="748.06371" y="744.45791" width="283" height="2" fill="#3f3d56" />
    // </svg>
  );
}
